
import { Component, Vue, Watch, Prop, Provide, ProvideReactive } from "vue-property-decorator"
import Guid from "@/scripts/guid"

// @ts-ignore
import VuePerfectScrollbar from "vue-perfect-scrollbar"

import TabButton from "./TabButton.vue"

@Component({
	components: {
		"scrollbar": VuePerfectScrollbar,
		"tab-button": TabButton
	}
})
export default class ScrollTabs extends Vue {
	@ProvideReactive("tabControl") private tabsControl = this;
	@ProvideReactive("activeId") private currentTabUid: string | null = null;

	@Prop({ type: Boolean, default: false })
	sortScrollTabs!: boolean

	@Prop({ type: Boolean, default: false })
	sortNonScrollTabs!: boolean

	tabs: any[] = [];

	public currentTab: any = null;

	public get activeTab () {
		return this.currentTab ? this.currentTab : this.tabs[0]
	}
	public get activeId () {
		return this.currentTabUid
	}
	public set activeId (value: string | null) {
		this.currentTabUid = value
	}

	public get nonScrollTabs () {
		return this.sortNonScrollTabs
			? this.sortTabs(this.tabs.filter(t => !t.scrollable))
			: this.tabs.filter(t => !t.scrollable)
	}

	public get scrollTabs () {
		return this.sortScrollTabs
			? this.sortTabs(this.tabs.filter(t => t.scrollable))
			: this.tabs.filter(t => t.scrollable)
	}

	created () {
		if (!this.tabs) {
			this.tabs = []
		}

		this.currentTab = null
		if (this.tabs.length > 0) {
			this.currentTab = this.tabs[0]
			this.activeId = this.tabs[0].id
		}
	}

	beforeDestroy () {
		this.activeId = null
	}

	public registerTab (tab: any): string {
		const id = Guid.newGuid()
		tab.id = id
		this.tabs.push(tab)

		if (!this.currentTab) {
			this.currentTab = tab
			this.activeId = id
		}

		return id
	}

	public unregisterTab (tab: any) {
		const tabIndex = this.tabs.indexOf(tab)
		if (tabIndex > -1) {
			this.tabs.splice(tabIndex, 1)
			if (tab.id === this.activeId) {
				this.activeId = this.tabs.length > 0 ? this.tabs[0].id : null
			}
		}
	}

	private setTab (newTab: any) {
		this.currentTab = newTab
		this.activeId = newTab.id
	}

	/**
	 * Returns a new array of tabs sorted alphabetically by their "title" prop.
	 * Tabs using slots instead of a "title" prop are treated as empty strings,
	 * so their original order is preserved. Safe to call even if all tabs use slots.
	 *
	 * @param {any[]} tabs - Array of tab objects to sort.
	 * @returns {any[]} Sorted array of tabs.
	 */
	private sortTabs (tabs: any[]) {
		return [...tabs].sort((a, b) => {
			const aContent = a.title ? String(a.title) : ""
			const bContent = b.title ? String(b.title) : ""
			return aContent.localeCompare(bContent)
		})
	}
}

